import React from 'react';
import { BookingButton } from '../components/BookingButton';
import { TestimonialCard } from '../components/TestimonialCard';
import { Accordion } from '../components/Accordion';
import { testimonials } from '../components/testimonials';
export function Workshop() {
  return <div className="w-full min-h-screen bg-[#F1F5F9] overflow-x-hidden pt-20" data-id="element-1165">
      {/* SECTION 1 — HERO OFERTĂ */}
      <section className="w-full bg-[#09111F] relative overflow-hidden py-20 md:py-32 text-center" data-id="element-1166">
        <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:24px_24px]" data-id="element-1167"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#1D4ED8] opacity-10 blur-[150px] rounded-full pointer-events-none" data-id="element-1168"></div>
        <div className="max-w-[900px] mx-auto px-5 md:px-12 relative z-10" data-id="element-1169">
          <h1 className="font-['Montserrat'] text-[clamp(40px,5vw,64px)] font-extrabold text-white leading-[1.1] mb-6" data-id="element-1170">
            Ieși din Haosul Operațional în 90 de Zile
          </h1>
          <p className="font-['Inter'] text-[20px] md:text-[24px] font-light text-[rgba(255,255,255,0.8)] leading-[1.6] mb-10" data-id="element-1171">
            Workshop online de 2-3 ore cu Valer Dura. Identifici blocajul. Alegi
            prioritățile. Pleci cu un plan.
          </p>
          <BookingButton text="Înscrie-te la Următorul Workshop — 197 €" href="/contact" className="px-10 py-5 text-[16px]" data-id="element-1172" />
        </div>
      </section>

      {/* SECTION 2 — DESCRIERE */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-1173">
        <div className="max-w-[800px] mx-auto px-5 md:px-12" data-id="element-1174">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-8 text-center" data-id="element-1175">
            Muncești din ce în ce mai mult, dar afacerea nu se mișcă înainte. De
            ce?
          </h2>
          <div className="space-y-6 font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8]" data-id="element-1176">
            <p data-id="element-1177">
              Ai trecut de faza de start-up. Ai echipă, ai clienți, ai cifră de
              afaceri. Dar te-ai plafonat. Lucrezi câte 10-12 ore pe zi, iei
              toate deciziile și tot tu ești cel care stinge incendiile. Nu mai
              e o problemă de efort. Muncești destul. E o problemă de direcție.
            </p>
            <p data-id="element-1178">
              Fiecare lună fără un plan clar și fără priorități concrete te
              costă bani, energie și oameni buni care se plictisesc sau pleacă.
              Cu cât amâni mai mult, cu atât plafonul devine mai greu de spart
              pentru că obiceiurile proaste se cimentează și echipa se
              obișnuiește să funcționeze în haos.
            </p>
            <p className="font-medium text-[#09111F] p-6 bg-[#F1F5F9] rounded-2xl border-l-4 border-[#1D4ED8]" data-id="element-1179">
              În acest workshop online de 2 până la 3 ore, analizăm împreună
              cele 8 componente ale afacerii tale, identificăm blocajul
              principal care te costă cel mai mult chiar acum și pleci cu 3
              priorități concrete și un plan de 90 de zile gata de implementat
              din ziua următoare.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 3A — CE SE ÎNTÂMPLĂ ÎN WORKSHOP */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-1180">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-1181">
          <div className="text-center mb-16" data-id="element-1182">
            <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-4" data-id="element-1183">
              Ce facem concret în cele 2-3 ore de workshop
            </h2>
          </div>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-1184">
            {[{
            title: 'Analiza celor 8 componente ProVi',
            items: ['Trecem prin fiecare din cele 8 componente esențiale ale unei afaceri sănătoase: mentalitate, viziune, oameni, numere, procese, probleme, progres și cash', 'Identifici pe loc unde ești puternic și unde ai breșa cea mai mare care îți sabotează creșterea', 'Primești un scor pe fiecare componentă care îți arată exact ordinea de prioritate']
          }, {
            title: 'Stabilirea obiectivului pe 90 de zile',
            items: ['Definești un singur obiectiv clar, concret și măsurabil pentru următorul trimestru', 'Înveți cum să formulezi obiectivul în așa fel încât echipa ta să îl înțeleagă și să îl poată urmări fără tine', "Ieși din logica de 'vreau să cresc' și intri în logica de 'știu exact ce trebuie să se întâmple în 90 de zile'"]
          }, {
            title: 'Alegerea a 3 priorități concrete',
            items: ['Selectezi maximum 3 priorități din toate lucrurile pe care le-ai putea face, pe baza impactului real, nu pe baza urgenței percepute', 'Fiecare prioritate primește un responsabil, un termen și un indicator de succes clar', 'Înveți de ce mai mult de 3 priorități pe trimestru înseamnă de fapt zero priorități']
          }, {
            title: 'Introducere în Tabela de Marcaj',
            items: ['Primești instrumentul cu care urmărești săptămânal dacă mergi în direcția bună sau nu', 'Valer îți arată cum să completezi tabela în 10 minute pe săptămână și cum să o citești corect', 'Pleci cu tabloul de bord gata configurat pentru afacerea ta, nu cu un template generic']
          }].map((block, index) => <div key={index} className="bg-white p-8 rounded-3xl shadow-[0_4px_20px_rgba(0,0,0,0.04)] border border-[rgba(0,0,0,0.04)]" data-id="element-1185">
                <div className="w-12 h-12 bg-[#EFF6FF] rounded-xl flex items-center justify-center mb-6 text-[#1D4ED8] font-bold text-xl" data-id="element-1186">
                  {index + 1}
                </div>
                <h3 className="font-['Montserrat'] text-[22px] font-bold text-[#09111F] mb-4" data-id="element-1187">
                  {block.title}
                </h3>
                <ul className="space-y-3" data-id="element-1188">
                  {block.items.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1189">
                      <div className="w-1.5 h-1.5 rounded-full bg-[#1D4ED8] mt-2.5 flex-shrink-0" data-id="element-1190"></div>
                      <span className="font-['Inter'] text-[16px] text-[#4B5563] leading-[1.6]" data-id="element-1191">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 4 — BENEFICII */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-1192">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12" data-id="element-1193">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-12 text-center" data-id="element-1194">
            Cu ce pleci după workshop
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1195">
            {[{
            title: 'Claritate asupra blocajului principal',
            desc: 'Nu mai ghicești ce nu merge. Știi exact care componentă din afacere te trage în jos și în ce ordine o repari.'
          }, {
            title: 'Un obiectiv trimestrial clar',
            desc: "Nu mai intri în trimestru cu 'să vedem ce iese'. Ai un obiectiv formulat concret pe care toată echipa îl poate urmări."
          }, {
            title: '3 priorități cu responsabil și termen',
            desc: 'Pleci cu 3 lucruri de făcut, nu cu 30. Fiecare are un om care răspunde de el și o dată la care se verifică.'
          }, {
            title: 'Tabela de marcaj configurată',
            desc: 'Instrumentul de control săptămânal, gata de folosit din prima zi după workshop. Același instrument folosit în programul de implementare de 12 luni.'
          }, {
            title: 'Un plan de 90 de zile pe o singură pagină',
            desc: 'Totul încape pe o foaie. Obiectivul, prioritățile, indicatorii, responsabilii, termenele. Fără documente de 50 de pagini pe care nimeni nu le citește.'
          }, {
            title: 'Acces la înregistrarea workshop-ului',
            desc: 'Poți revedea conținutul oricând și poți folosi exercițiile la fiecare început de trimestru ca să îți refaci planul.'
          }].map((benefit, i) => <div key={i} className="bg-[#F1F5F9] rounded-2xl p-6 border border-[rgba(0,0,0,0.04)]" data-id="element-1196">
                <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center mb-4 text-[#1D4ED8] shadow-sm" data-id="element-1197">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-1198">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-1199"></path>
                  </svg>
                </div>
                <h3 className="font-['Montserrat'] text-[18px] font-bold text-[#09111F] mb-2" data-id="element-1200">
                  {benefit.title}
                </h3>
                <p className="font-['Inter'] text-[15px] text-[#4B5563] leading-[1.6]" data-id="element-1201">
                  {benefit.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 5 — CINE SUNT EU */}
      <section className="w-full bg-[#0A1628] py-16 md:py-24 text-white" data-id="element-1202">
        <div className="max-w-[800px] mx-auto px-5 md:px-12 text-center" data-id="element-1203">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold mb-8" data-id="element-1204">
            Cine conduce workshop-ul și de ce contează asta
          </h2>
          <div className="space-y-6 font-['Inter'] text-[19px] font-light text-[rgba(255,255,255,0.8)] leading-[1.8] text-left" data-id="element-1205">
            <p data-id="element-1206">
              Sunt Valer Dura. Am construit, eficientizat și vândut propriile
              afaceri cu cifre de milioane de euro. De 12 ani lucrez direct cu
              antreprenori și echipe de lideri din companii românești și știu
              din interior cum arată haosul operațional în care ajungi când
              afacerea crește fără sistem.
            </p>
            <p data-id="element-1207">
              Nu conduc acest workshop dintr-o carte. Îl conduc din experiența
              directă de a fi trecut eu însumi prin plafonare, prin urgențe
              zilnice și prin momentul în care am înțeles că problema nu era cât
              muncesc, ci cum muncesc.
            </p>
            <p data-id="element-1208">
              ProVi System este construit pe cele 8 componente pe care le-am
              descoperit, testat și rafinat în propriile afaceri și în
              companiile clienților mei. Workshop-ul este cea mai rapidă cale de
              a înțelege unde ești tu acum, ce te blochează și care sunt primii
              3 pași pe care îi faci trimestrul acesta.
            </p>
            <p className="font-medium text-white border-l-4 border-[#3B82F6] pl-6 py-2" data-id="element-1209">
              Nu primești motivație. Primești un plan pe care îl poți aplica din
              ziua următoare.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 6 — PENTRU CINE ESTE / NU ESTE */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-1210">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-1211">
          <div className="grid md:grid-cols-2 gap-8" data-id="element-1212">
            <div className="bg-[#EFF6FF] rounded-3xl p-8 border border-[rgba(59,130,246,0.2)]" data-id="element-1213">
              <h3 className="font-['Montserrat'] text-[24px] font-bold text-[#09111F] mb-6 flex items-center gap-3" data-id="element-1214">
                <div className="w-8 h-8 rounded-full bg-[#1D4ED8] text-white flex items-center justify-center" data-id="element-1215">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-1216">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-1217"></path>
                  </svg>
                </div>
                Pentru cine este workshop-ul:
              </h3>
              <ul className="space-y-4" data-id="element-1218">
                {['Ești antreprenor cu minimum 3 angajați care muncește mult dar simte că afacerea nu crește proporțional cu efortul depus', 'Ești lider de departament care vrea mai multă claritate în obiective și un sistem de urmărire a echipei', 'Vrei să înțelegi cum funcționează ProVi System înainte de a investi într-un program complet de implementare'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1219">
                    <div className="w-2 h-2 rounded-full bg-[#1D4ED8] mt-2 flex-shrink-0" data-id="element-1220"></div>
                    <span className="font-['Inter'] text-[17px] text-[#4B5563] leading-[1.6]" data-id="element-1221">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
            <div className="bg-[#FEF2F2] rounded-3xl p-8 border border-[rgba(239,68,68,0.2)]" data-id="element-1222">
              <h3 className="font-['Montserrat'] text-[24px] font-bold text-[#09111F] mb-6 flex items-center gap-3" data-id="element-1223">
                <div className="w-8 h-8 rounded-full bg-[#EF4444] text-white flex items-center justify-center" data-id="element-1224">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-1225">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" data-id="element-1226"></path>
                  </svg>
                </div>
                Pentru cine nu este workshop-ul:
              </h3>
              <ul className="space-y-4" data-id="element-1227">
                {['Ești la început de drum și nu ai echipă, workshop-ul este construit pentru afaceri care au deja oameni', 'Cauți motivație și energie, nu un plan concret de acțiune', 'Nu ești dispus să aloci 2-3 ore de concentrare reală și să faci exercițiile din workshop în timp real'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1228">
                    <div className="w-2 h-2 rounded-full bg-[#EF4444] mt-2 flex-shrink-0" data-id="element-1229"></div>
                    <span className="font-['Inter'] text-[17px] text-[#4B5563] leading-[1.6]" data-id="element-1230">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 7 — RECAPITULARE INVESTIȚIE */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-1231">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-1232">
          <div className="bg-white rounded-3xl p-8 md:p-12 border-2 border-[#1D4ED8] shadow-[0_20px_40px_rgba(29,78,216,0.08)] relative" data-id="element-1233">
            <div className="absolute -top-4 inset-x-0 flex justify-center" data-id="element-1234">
              <span className="bg-[#1D4ED8] text-white font-['Montserrat'] text-[12px] font-bold tracking-[0.15em] uppercase px-6 py-2 rounded-full shadow-md" data-id="element-1235">
                RECAPITULARE
              </span>
            </div>
            <h2 className="font-['Montserrat'] text-[28px] md:text-[36px] font-bold text-[#09111F] mb-8 text-center mt-4" data-id="element-1236">
              Hai să recapitulăm ce primești în Workshop-ul Intensiv
            </h2>

            <div className="flex flex-col gap-12" data-id="element-1237">
              <div data-id="element-1238">
                <h3 className="font-['Montserrat'] text-[20px] font-bold text-[#1D4ED8] mb-6 border-b pb-2" data-id="element-1239">
                  Ce este inclus:
                </h3>
                <ul className="space-y-4" data-id="element-1240">
                  {['Workshop online live de 2 până la 3 ore cu Valer Dura', 'Analiza celor 8 componente ProVi aplicată pe afacerea ta', 'Obiectiv trimestrial și 3 priorități definite în workshop', 'Tabela de marcaj configurată pentru afacerea ta', 'Acces la înregistrarea completă a workshop-ului'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1241">
                      <svg className="w-5 h-5 text-[#1D4ED8] flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-1242">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-1243"></path>
                      </svg>
                      <span className="font-['Inter'] text-[15px] text-[#4B5563] leading-[1.6]" data-id="element-1244">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>
              <div data-id="element-1245">
                <h3 className="font-['Montserrat'] text-[20px] font-bold text-[#F59E0B] mb-6 border-b pb-2" data-id="element-1246">
                  Bonusuri:
                </h3>
                <ul className="space-y-4 mb-8" data-id="element-1247">
                  {['Planul trimestrial pe o pagină, template gata de folosit la fiecare început de trimestru', 'Checklist de evaluare a celor 8 componente pe care o poți reface singur la fiecare 90 de zile'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1248">
                      <svg className="w-5 h-5 text-[#F59E0B] flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-1249">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" data-id="element-1250"></path>
                      </svg>
                      <span className="font-['Inter'] text-[15px] text-[#4B5563] leading-[1.6]" data-id="element-1251">
                        {item}
                      </span>
                    </li>)}
                </ul>

                <div className="bg-[#F1F5F9] rounded-xl p-6 text-center border border-[rgba(0,0,0,0.05)]" data-id="element-1252">
                  <p className="font-['Inter'] text-[15px] text-[#6B7280] line-through mb-1" data-id="element-1253">
                    Valoare totală reală: 497 €
                  </p>
                  <p className="font-['Montserrat'] text-[32px] font-bold text-[#09111F] mb-2" data-id="element-1254">
                    197 €{' '}
                    <span className="text-[15px] font-normal text-[#6B7280]" data-id="element-1255">
                      / participant
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-12 text-center" data-id="element-1256">
              <BookingButton text="Înscrie-te la Următorul Workshop — 197 €" href="/contact" className="px-10 py-5 text-[16px] w-full sm:w-auto" data-id="element-1257" />
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 8 — TESTIMONIALE */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-1258">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12" data-id="element-1259">
          <div className="text-center mb-16" data-id="element-1260">
            <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F]" data-id="element-1261">
              Ce spun antreprenorii care au participat la workshop
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-1262">
            {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-1263" />)}
          </div>
        </div>
      </section>

      {/* SECTION 9 — ÎNTREBĂRI FRECVENTE */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-1264">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-1265">
          <div className="text-center mb-16" data-id="element-1266">
            <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F]" data-id="element-1267">
              Întrebări Frecvente
            </h2>
          </div>
          <Accordion items={[{
          question: 'Workshop-ul este live sau înregistrat?',
          answer: 'Este live, online, prin Zoom. Lucrezi în timp real pe exerciții aplicate pe afacerea ta. După workshop primești acces la înregistrarea completă pe care o poți revedea oricând.'
        }, {
          question: 'Pot participa dacă am o echipă foarte mică, de 3-5 oameni?',
          answer: 'Da. Workshop-ul este construit exact pentru antreprenorii cu echipe mici și medii. Cu cât echipa e mai mică, cu atât mai rapid se simte impactul unui plan clar și a unor priorități bine alese.'
        }, {
          question: 'Ce se întâmplă dacă nu pot participa la data programată?',
          answer: 'Primești acces la înregistrare și poți parcurge materialele pe cont propriu. Dacă vrei experiența live, te poți înscrie la ediția următoare fără cost suplimentar.'
        }, {
          question: 'Cum e diferit față de un webinar sau un curs online gratuit?',
          answer: 'Nu este un webinar. Nu urmărești un ecran. Lucrezi activ pe exerciții aplicate pe situația ta reală. Pleci cu un plan concret, nu cu notițe teoretice pe care le uiți în 3 zile.'
        }, {
          question: 'Trebuie să pregătesc ceva înainte de workshop?',
          answer: 'Da. Înainte de workshop primești un chestionar scurt de diagnostic pe care îl completezi în 10 minute. Acesta ne permite să lucrăm direct pe situația ta, nu pe exemple generice.'
        }, {
          question: 'Pot participa împreună cu un lider din echipa mea?',
          answer: 'Da, și este recomandat. Dacă participi cu un lider de departament sau cu un cofondator, impactul e mai mare pentru că construiți planul trimestrial împreună și plecați aliniați. Fiecare participant plătește 197 €.'
        }, {
          question: 'Ce se întâmplă după workshop dacă vreau mai mult?',
          answer: 'Workshop-ul este primul nivel din ecosistemul ProVi System. Dacă după workshop vrei implementare mai profundă, poți accesa ProVi Accelerator (program de grup, 12 săptămâni) sau implementarea completă de 12 luni. Investiția în workshop se deduce din programele superioare.'
        }]} data-id="element-1268" />
        </div>
      </section>
    </div>;
}